import { useParams } from 'react-router-dom'
import { usePaymentRequests } from '@/hooks/usePayment'
import './PaymentDetail.css'

const PaymentDetail = () => {
    const { id } = useParams()
    const { data, isLoading, isError } = usePaymentRequests()
    const item = (data || []).find((p: any) => String(p.id) === String(id))
    return (
        <div className="payment-detail-page">
            <div className="payment-detail-container">
                <h2 className="payment-detail-title">Detalle de Pago #{id}</h2>
                {isLoading ? (
                    <div className="payment-detail-message">Cargando...</div>
                ) : isError ? (
                    <div className="payment-detail-message">Error al cargar pago</div>
                ) : item ? (
                    <div className="payment-detail-content">
                        <div><strong>Monto:</strong> S/ {item.amount}</div>
                        <div><strong>Método:</strong> {item.payment_method}</div>
                        <div><strong>Estado:</strong> {item.status_display || item.status}</div>
                        <div><a href={item.receipt_image_url} target="_blank" rel="noreferrer">Ver Comprobante</a></div>
                    </div>
                ) : (
                    <div className="payment-detail-message">Pago no encontrado</div>
                )}
            </div>
        </div>
    )
}

export default PaymentDetail


